import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, radii } from '../../theme/tokens';

type IconCardProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  id?: string;
  headingLevel?: 'h3' | 'h4';
};

const IconCard: React.FC<IconCardProps> = ({ icon, title, description, id, headingLevel = 'h3' }) => (
  <Box
    id={id}
    sx={{
      height: '100%',
      p: { xs: 3, md: 3.5 },
      borderRadius: radii.lg,
      backgroundColor: colors.surface,
      border: `1px solid ${colors.border}`,
      transition: 'transform .25s ease, border-color .25s ease, background-color .25s ease',
      scrollMarginTop: 110,
      '&:hover': {
        transform: 'translateY(-4px)',
        borderColor: colors.borderStrong,
        backgroundColor: colors.surfaceHover,
      },
    }}
  >
    <Box
      sx={{
        width: 52,
        height: 52,
        borderRadius: radii.md,
        display: 'grid',
        placeItems: 'center',
        backgroundColor: colors.accentSoft,
        border: `1px solid rgba(252, 106, 1, 0.28)`,
        color: colors.accent,
        mb: 2.5,
        '& svg': { fontSize: 26 },
      }}
    >
      {icon}
    </Box>
    <Typography component={headingLevel} variant="h5" sx={{ color: colors.text, mb: 1, fontSize: '1.2rem' }}>
      {title}
    </Typography>
    <Typography variant="body2" sx={{ color: colors.textMuted }}>
      {description}
    </Typography>
  </Box>
);

export default IconCard;
